import { RatingReg } from '../types/ViewModel/RatingReg';
import { RatingRegBM } from '../types/BusinessModel/RatingRegBM';

export default () => {
    const newRatingReg = (ratingReg: RatingRegBM): RatingReg => {
        return new RatingReg(ratingReg.ratingRegId, ratingReg.ratingValue, ratingReg.ratingComment);
    };

    const newRatingRegFromCode = (ratingRegId: string, ratingRegValue: number, ratingRegComment: string | null): RatingReg => {
        return new RatingReg(ratingRegId, ratingRegValue, ratingRegComment);
    };

    const createRatingReg = (ratingReg: RatingReg | null): RatingReg | null => {
        if (ratingReg) {
            return new RatingReg(ratingReg.ratingRegId, ratingReg.ratingValue, ratingReg.ratingComment);
        }
        return null;
    };

    const createRatingRegBM = (ratingReg: RatingReg | null): any => {
        if (ratingReg) {
            return new RatingReg(ratingReg.ratingRegId, ratingReg.ratingValue, ratingReg.ratingComment);
        }
        return null;
    };

    return {
        newRatingReg,
        newRatingRegFromCode,
        createRatingReg,
        createRatingRegBM,
    };
};
